import ProfessionalPackageCreate from './ProfessionalPackageCreate'
import ProfessionalPackageEdit from './ProfessionalPackageEdit'
import { buildPackageList } from 'ui-shared/WrappedInputs/Packages/BasePackageList'

const professionalPackageIndex = {
  list: buildPackageList('professionals'),
  edit: ProfessionalPackageEdit,
  create: ProfessionalPackageCreate,
}

export default professionalPackageIndex
